export function sortByTime(items, key) {
  return items.sort((a, b) => {
    // Parse the time strings as Date objects
    const timeA = new Date(`1970-01-01T${a[key]}`);
    const timeB = new Date(`1970-01-01T${b[key]}`);

    // Compare the Date objects
    return timeA - timeB;
  });
}